import React from 'react';
import {
    Error,
    Loading,
    useQuery
} from 'react-admin';

const CustomShow = props => {
    const {data, loading, error} = useQuery({
        type: 'getOneShow',
        resource: 'hotels',
        payload: {id: props.id}
    });
    if (loading) return <Loading/>;
    if (error) return <Error/>;
    if (!data) return null;
    return (
        <div>
            <div><strong>Hotel id:</strong> {data.id}</div>
            <div><strong>Title:</strong> {data.title}</div>
            <div><strong>Provider:</strong> {data.provider}</div>
            <div><strong>City:</strong> {data.city}</div>
            <div><strong>Address:</strong> {data.address}</div>
            <div><strong>Stars:</strong> {data.stars}</div>
            <div><strong>Created:</strong> {data.external_created_at}</div>

            <br/>
            <br/>
            {data.owner && data.owner.userIdentifier ? <div>
                <div><strong>Extranet User</strong></div>
                <br/>
                <div><strong>Id:</strong> {data.owner ? data.owner.userIdentifier : null}</div>
                <div><strong>First name:</strong> {data.owner ? data.owner.firstName : null}</div>
                <div><strong>Last name:</strong> {data.owner ? data.owner.lastName : null}</div>
                <div><strong>Phone Number:</strong> {data.owner ? data.owner.phoneNumber : null}</div>
                <div><strong>Email:</strong> {data.owner ? data.owner.email : null}</div>
                <div><strong>Is Verified:</strong> {data.owner ? data.owner.isVerified : null}</div>
                <div><strong>Hotel
                    IDs:</strong> {data.owner && data.owner.hotelIds?.length ? data.owner.hotelIds.join(', ') : null}
                </div>
            </div> : null}
        </div>
    );
};

export const HotelsShow = (props) => (
    <CustomShow {...props}>
    </CustomShow>
);
